/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';

.patient-education-dialog {
  .MuiDialog-container {
    .MuiPaper-root {
      width: 100%;
      max-width: 720px;
    }
  }

  .MuiDialog-paper {
    border-radius: 12px;
  }

  .MuiDialogActions-root {
    padding-bottom: 4px;
  }

  .title {
    display: flex;
    align-content: center;
    justify-content: space-between;
  }

  .close-icon-button {
    position: absolute;
    top: 8px;
    right: 8px;
  }

  .action-btn-container {
    justify-content: center;
    padding: 16px;
  }

  button.MuiButtonBase-root {
    height: variables.$footer-button-height;
    border-radius: variables.$footer-button-height;
    color: variables.$color-black;
    font-weight: normal;

    &:hover {
      background-color: variables.$footer-button-color-hover;
    }
  }
}
